import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
import * as format from "../../common/FormatFunctions";
export class ProductViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getStockOptions = () => {
    var stockOptions = Storage.parseStockOptions();
    this.updateState("stockTypeOptions", stockOptions);
  };

  getOperationalTypeOptions = () => {
    var productTypeArray = Storage.parseOperationalTypeOptions();
    this.updateState("operationalTypeOptions", productTypeArray);
  };

  getProductTypeOptions = () => {
    var productTypeArray = Storage.parseProductTypeOptions();
    this.updateState("productTypeOptions", productTypeArray);
  };

  getProducts = async (partList, subList) => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var productResponse = await this.getProductListByCodeTag();
    if (
      Format.isNotNull(productResponse.errorCode) &&
      productResponse.errorCode === 0
    ) {
      if (Format.isNotNull(productResponse.productList)) {
        productResponse.productList.forEach(async element => {
          element.selectedComponents = this.getComponentListFromProductResponse(
            element,
            partList,
            subList
          );
          element.flowRequest = await this.getFlowBeanForEntityAndEntityType(
            element.selectedComponents,
            element.id,
            "PRODUCT",
            this.getComponentList(partList, subList, true)
          );
        });
        this.updateState("productList", productResponse.productList);
        this.logger.info(productResponse.productList);
      } else {
        this.showEmpty("Product");
      }
    } else {
      this.showError("Product", CrudlStatus.LIST);
    }
  };
  getProductAndFlow = async (partList, subList, id) => {
    let productRequest = new CloudService.ProductRequest();
    productRequest.codeTag = this.codeTag;
    productRequest.userId = this.userId;
    productRequest.id = id;

    var productResponse = await ApiService.productGetById(productRequest);
    var loadedFlowBean = {};
    if (productResponse.errorCode === 0) {
      productResponse.selectedComponents = this.getComponentListFromProductResponse(
        productResponse,
        partList,
        subList
      );
      productResponse.flowRequest = await this.getFlowBeanForEntityAndEntityType(
        productResponse.selectedComponents,
        productResponse.id,
        "PRODUCT",
        this.getComponentList(partList, subList, true)
      );

      delete productResponse.flowResponseList;
    }

    return productResponse;
  };
  getProductsReturned = async (partList, subList) => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var productResponse = await this.getProductListByCodeTag();
    if (
      Format.isNotNull(productResponse.errorCode) &&
      productResponse.errorCode === 0
    ) {
      if (Format.isNotNull(productResponse.productList)) {
        productResponse.productList.forEach(async element => {
          element.selectedComponents = this.getComponentListFromProductResponse(
            element,
            partList,
            subList
          );
          element.flowRequest = await this.getFlowBeanForEntityAndEntityType(
            element.selectedComponents,
            element.id,
            "PRODUCT",
            this.getComponentList(partList, subList, true)
          );
        });
        this.logger.info(productResponse.productList);
        return productResponse.productList;
      } else {
        this.showEmpty("Product");
      }
    } else {
      this.showError("Product", CrudlStatus.LIST);
    }
  };

  getParts = async () => {
    var partResponse = await this.getPartListByCodeTag();
    if (
      Format.isNotNull(partResponse.errorCode) &&
      partResponse.errorCode === 0
    ) {
      if (Format.isNotNull(partResponse.partList)) {
        this.updateState("partList", partResponse.partList);
        this.logger.info(partResponse.partList);
      } else {
        this.showEmpty("Product");
      }
    } else {
      this.showError("Part", CrudlStatus.LIST);
    }
  };

  getSubAssemblys = async () => {
    var productResponse = await this.getProductListByCodeTag();
    if (
      Format.isNotNull(productResponse.errorCode) &&
      productResponse.errorCode === 0
    ) {
      if (Format.isNotNull(productResponse.productList)) {
        var subAssemblyFilteredList = [];
        productResponse.productList.forEach(element => {
          // if (element.productType === "SUBASSEMBLY") {
          subAssemblyFilteredList.push(element);
          // }
        });
        this.updateState("subAssemblyList", subAssemblyFilteredList);
        this.logger.info(subAssemblyFilteredList);
      } else {
        this.showEmpty("Sub Assembly");
      }
    } else {
      this.showError("Sub Assembly", CrudlStatus.LIST);
    }
  };

  getStations = async () => {
    var stationResponse = await this.getStationListByCodeTag();
    if (
      Format.isNotNull(stationResponse.errorCode) &&
      stationResponse.errorCode === 0
    ) {
      if (Format.isNotNull(stationResponse.stationList)) {
        this.updateState("stationList", stationResponse.stationList);
        var attributeArray = UIMap.getListOptions(
          stationResponse.stationList,
          "name"
        );
        var attributeMap = UIMap.getDropdownOptions(
          stationResponse.stationList
        );
        this.updateState("stationMap", attributeMap);
        this.updateState("stationOptions", attributeArray);
        this.logger.info(stationResponse.stationList);
      } else {
        //this.showEmpty("Station")
      }
    } else {
      this.showError("Station", CrudlStatus.LIST);
    }
  };
  getAttributeSets = async () => {
    //NON CRITICAL - NO ERROR MESSAGE
    var attributeSetResponse = await this.getAttributeSetListByCodeTag();
    if (
      Format.isNotNull(attributeSetResponse.errorCode) &&
      attributeSetResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeSetResponse.attributeSetList)) {
        this.logger.info(attributeSetResponse.attributeSetList);
        this.updateState(
          "attributeSetList",
          attributeSetResponse.attributeSetList
        );

        var attributeArray = UIMap.getListOptions(
          attributeSetResponse.attributeSetList,
          "name"
        );
        var attributeMap = UIMap.getDropdownOptions(
          attributeSetResponse.attributeSetList
        );
        this.updateState("attributeSetMap", attributeMap);
        this.updateState("attributeSetOptions", attributeArray);
      } else {
        //this.showEmpty("AttributeSet");
      }
    } else {
      //this.showError("AttributeSet", CrudlStatus.LIST);
    }
  };

  getSuppliers = async () => {
    //NON CRITICAL - NO ERROR MESSAGE
    var supplierResponse = await this.getAttributeSetListByCodeTag();
    if (
      Format.isNotNull(supplierResponse.errorCode) &&
      supplierResponse.errorCode === 0
    ) {
      if (Format.isNotNull(supplierResponse.buisnesses)) {
        this.logger.info(supplierResponse.buisnesses);
        this.updateState("supplierList", supplierResponse.buisnesses);

        var array = UIMap.getListOptions(supplierResponse.buisnesses, "name");
        var map = UIMap.getDropdownOptionsExtension(
          supplierResponse.buisnesses,
          "name",
          "name"
        );
        this.updateState("supplierMap", map);
        this.updateState("supplierOptions", array);
      } else {
        //this.showEmpty("Supplier");
      }
    } else {
      //this.showError("Supplier", CrudlStatus.LIST);
    }
  };

  getComponentList = (partList, subAssemblyList, returnValue) => {
    var componentList = [];

    if (format.isNotNull(partList)) {
      partList.forEach(element => {
        var localPart = format.deepCopy(element);
        localPart.componentType = "PART";
        componentList.push(localPart);
      });
    }
    if (format.isNotNull(subAssemblyList)) {
      subAssemblyList.forEach(element => {
        var localPart = format.deepCopy(element);
        localPart.componentType = "SUB-ASSEMBLY";
        componentList.push(localPart);
      });
    }
    console.log(componentList);
    if (returnValue === true) {
      return componentList;
    } else {
      this.updateState("componentList", componentList);
    }
  };

  reloadDataAfterExecute = (
    products,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedProductList = [];
    if (type === CrudlStatus.CREATE) {
      updatedProductList = this.reloadAfterCreate(
        products,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedProductList = this.reloadAfterUpdate(
        products,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedProductList = this.reloadAfterDelete(
        products,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("productList", updatedProductList);
  };

  reloadAfterCreate = (productList, apiResponse, externalStateValues) => {
    if (productList === undefined || productList === null) {
      productList = [];
    }
    var productBean = externalStateValues.productBean;
    productBean.id = apiResponse.id;
    productBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    productList.push(productBean);

    return productList;
  };

  reloadAfterUpdate = (productList, apiResponse, externalStateValues) => {
    var i = 0;
    productList.forEach(e => {
      if (apiResponse.id === e.id) {
        productList[i] = externalStateValues.productBean;
        productList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return productList;
  };

  reloadAfterDelete = (productList, apiResponse, externalStateValues) => {
    var i = 0;
    productList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        productList.splice(i, 1);
      }
      i++;
    });

    return productList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let productRequest = stateVariables.productBean;

    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createProduct(productRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateProduct(productRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteProduct(productRequest);
    }
  };

  createProduct = async (productRequest, stateVariables) => {
    productRequest.codeTag = this.codeTag;
    productRequest.userId = this.userId;

    productRequest.partProductJson = this.parsePartProductJson(
      productRequest.selectedComponents
    );

    if (format.isNotNull(productRequest.flowRequest)) {
      if (format.isNotNull(productRequest.flowRequest.flowItemList)) {
        var flowRequestList = [];
        var flowRequest = this.renderJsonFromPartsAndProducts(
          format.deepCopy(productRequest.flowRequest),
          productRequest.selectedComponents,
          productRequest.id
        );
        delete flowRequest.fullFlowResponseList;
        flowRequestList.push(flowRequest);
        productRequest.flowRequestList = flowRequestList;
      }
    } else {
      // NO NEED TO DO ANYTHING REQUEST WONT PASS UP FLOW JUST
    }
    delete productRequest.treeTableComponents;

    let productResponse = await ApiService.productCreate(productRequest);
    if (productResponse.errorCode === 0) {
      this.showSuccess("Product", CrudlStatus.CREATE);
    } else {
      this.showError("Product", CrudlStatus.CREATE);
    }

    return productResponse;
  };

  deleteProduct = async productRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = productRequest.id;
    request.lastUpdatedDateTime = productRequest.lastUpdatedDateTime;

    let productResponse = await ApiService.productDelete(request);
    if (productResponse.errorCode === 0) {
      this.showSuccess("Product", CrudlStatus.DELETE);
    } else {
      this.showError("Product", CrudlStatus.DELETE);
    }

    return productResponse;
  };

  updateProduct = async (productRequest, stateVariables) => {
    productRequest.codeTag = this.codeTag;
    productRequest.userId = this.userId;
    console.log(productRequest);
    productRequest.partProductJson = this.parsePartProductJson(
      format.deepCopy(productRequest.selectedComponents)
    );
    if (format.isNotNull(productRequest.flowRequest)) {
      if (format.isNotNull(productRequest.flowRequest.flowItemList)) {
        var flowRequest = this.renderJsonFromPartsAndProducts(
          format.deepCopy(productRequest.flowRequest),
          productRequest.selectedComponents,
          productRequest.id
        );

        await this.updateOriginalFlowBean(
          flowRequest.id,
          flowRequest.lastUpdatedDateTime
        );
      }

      flowRequest.entityId = productRequest.id;
      flowRequest.entityName = "PRODUCT";
      delete flowRequest.fullFlowResponseList;
      var createErrorCode = await this.saveFlow(flowRequest);
    } else {
      // NO NEED TO DO ANYTHING REQUEST WONT PASS UP FLOW JUST
    }
    delete productRequest.treeTableComponents;

    let productResponse = await ApiService.productUpdate(productRequest);
    if (productResponse.errorCode === 0) {
      this.showSuccess("Product", CrudlStatus.UPDATE);
    } else {
      this.showError("Product", CrudlStatus.UPDATE);
    }

    return productResponse;
  };

  //Front End Data Manupilation

  getComponentListFromProductResponse = (
    productResponse,
    partList,
    subAssemblyList
  ) => {
    var selectedParts = [];
    var selectedSubs = [];

    if (Format.isNotNull(productResponse)) {
      var parse = JSON.parse(productResponse.partProductJson);
      if (Format.isNotNull(parse)) {
        selectedParts = parse.parts;
        selectedSubs = parse.products;
      }
    }

    var parsedPartList = [];
    var parsedSubList = [];
    partList.forEach(partBean => {
      selectedParts.forEach(selectedPartBean => {
        if (selectedPartBean.id === partBean.id) {
          var bean = Format.deepCopy(partBean);
          bean.quantity = selectedPartBean.quantity;
          parsedPartList.push(bean);
        }
      });
    });

    subAssemblyList.forEach(partBean => {
      selectedSubs.forEach(selectedPartBean => {
        if (selectedPartBean.id === partBean.id) {
          var bean = Format.deepCopy(partBean);
          bean.quantity = selectedPartBean.quantity;
          parsedSubList.push(bean);
        }
      });
    });

    var componentList = [];

    if (format.isNotNull(parsedPartList)) {
      parsedPartList.forEach(element => {
        var localPart = format.deepCopy(element);
        localPart.componentType = "PART";
        componentList.push(localPart);
      });
    }
    if (format.isNotNull(parsedSubList)) {
      parsedSubList.forEach(element => {
        var localPart = format.deepCopy(element);
        localPart.componentType = "SUB-ASSEMBLY";
        componentList.push(localPart);
      });
    }
    return componentList;
  };

  parsePartProductJson = componentList => {
    console.log(componentList);
    return JSON.stringify({
      parts: this.parseSelectedParts(componentList),
      products: this.parseSelectedSubAssemblys(componentList)
    });
  };

  parseSelectedParts = list => {
    var partList = Format.deepCopy(list);

    var parsedPartList = [];
    partList.forEach(element => {
      if (element.componentType === "PART") {
        var localBean = Format.parsePojoRow(element.id, element.quantity);
        parsedPartList.push(localBean);
      }
    });

    var partListJson = parsedPartList;
    return partListJson;
  };

  parseSelectedSubAssemblys = list => {
    var partList = Format.deepCopy(list);

    var parsedPartList = [];
    partList.forEach(element => {
      if (element.componentType === "SUB-ASSEMBLY") {
        var localBean = Format.parsePojoRow(element.id, element.quantity);
        parsedPartList.push(localBean);
      }
    });

    var partListJson = parsedPartList;
    return partListJson;
  };
  //FLOW SPECIFICS

  saveFlow = async flowBean => {
    var flowBeanParsed = Format.deepCopy(flowBean);

    this.logger.info(flowBeanParsed);
    let flowRequest = CloudService.FlowRequest.constructFromObject(
      flowBeanParsed
    );

    flowRequest.codeTag = this.codeTag;
    flowRequest.userId = this.userId;

    let flowResponse = await ApiService.flowCreate(flowRequest);
    if (Format.isNotNull(flowResponse)) {
      return flowResponse.errorCode;
    } else {
      return 9999;
    }
  };

  updateOriginalFlowBean = async (id, lastUpdatedDateTime) => {
    var flowRequest = new CloudService.FlowRequest();

    flowRequest.codeTag = this.codeTag;
    flowRequest.userId = this.userId;
    flowRequest.id = id;
    flowRequest.lastUpdatedDateTime = lastUpdatedDateTime;
    flowRequest.active = false;

    let flowResponse = await ApiService.flowUpdate(flowRequest);
    this.logger.info(flowResponse);
    if (Format.isNotNull(flowResponse)) {
      return flowResponse.errorCode;
    } else {
      return 9999;
    }
  };

  getFlowBeanForEntityAndEntityType = async (
    componentList,
    entityId,
    entityType,
    fullComponentList
  ) => {
    if (entityType === "PRODUCT") {
      let productRequest = new CloudService.ProductRequest();
      productRequest.codeTag = this.codeTag;
      productRequest.userId = this.userId;
      productRequest.id = entityId;

      var productResponse = await ApiService.productGetByIdAndFlow(
        productRequest
      );
      var loadedFlowBean = {};
      if (productResponse.errorCode === 0) {
        if (Format.isNotNull(productResponse.flowResponseList)) {
          productResponse.flowResponseList.forEach(flow => {
            if (Format.isNotNull(flow.flowItemResponseList)) {
              var length = flow.flowItemResponseList.length;
              var index = 1;
              flow.flowItemResponseList.forEach(flowItem => {
                if (index === length) {
                  var productList = JSON.parse(flowItem.outputJson).products;
                  productList.forEach(product => {
                    if (product.id === entityId) {
                      loadedFlowBean = this.convertFlowResponseToFlowBean(flow);
                      loadedFlowBean = this.renderPartsAndProductsFromJson(
                        loadedFlowBean,
                        fullComponentList
                      );
                    }
                  });
                } else {
                  index++;
                }
              });
            }
          });

          this.updateState("crudlStatus", CrudlStatus.UPDATE);
          this.logger.info(loadedFlowBean);
          //PARSE ALL FLOWS THE SAME WAY
          var fullFlowList = [];
          productResponse.flowResponseList.forEach(flow => {
            var flowBean = this.convertFlowResponseToFlowBean(flow);
            flowBean = this.renderPartsAndProductsFromJson(
              flowBean,
              fullComponentList
            );
            fullFlowList.push(format.deepCopy(flowBean));
          });
          loadedFlowBean.fullFlowList = fullFlowList;
          return loadedFlowBean;
        } else {
          loadedFlowBean = new CloudService.FlowBean();
          loadedFlowBean.entityId = entityId;
          loadedFlowBean.entityType = entityType;
          this.updateState("crudlStatus", CrudlStatus.CREATE);
          this.logger.info(loadedFlowBean);
          return loadedFlowBean;
        }
      } else {
        loadedFlowBean = new CloudService.FlowBean();
        loadedFlowBean.entityId = entityId;
        loadedFlowBean.entityType = entityType;
        this.updateState("crudlStatus", CrudlStatus.CREATE);
        this.logger.info(loadedFlowBean);
        return loadedFlowBean;
      }
    } else {
    }
  };

  convertFlowResponseToFlowBean = flowResponse => {
    // flowItemResponseList => flowItemList

    var localFlowResponse = Format.deepCopy(flowResponse);

    var flowBean = CloudService.FlowBean.constructFromObject(localFlowResponse);

    flowBean.flowItemList = localFlowResponse.flowItemResponseList;

    return flowBean;
  };

  convertFlowBeanToFlowRequest = flowBean => {
    return flowBean;
  };

  renderPartsAndProductsFromJson = (flowBean, componentList) => {
    var partList = [];
    var productList = [];

    componentList.forEach(element => {
      if (element.componentType === "PART") {
        partList.push(element);
      } else {
        productList.push(element);
      }
    });
    var localFlowBean = Format.deepCopy(flowBean);
    if (Format.isNotNull(localFlowBean.flowItemList)) {
      localFlowBean.flowItemList.forEach(element => {
        var parsedInputPartList = [];
        var parsedInputProductList = [];
        var parsedOutputPartList = [];
        var parsedOutputProductList = [];

        if (Format.isNotNull(element.inputJson)) {
          var inputPartList = JSON.parse(element.inputJson).parts;
          if (Format.isNotNull(inputPartList)) {
            inputPartList.forEach(inputPart => {
              if (Format.isNotNull(partList)) {
                componentList.forEach(part => {
                  var parsedInputPart = inputPart;
                  if (parsedInputPart.id === part.id) {
                    var quantity = 1;
                    if (parsedInputPart.quantity) {
                      quantity = parsedInputPart.quantity;
                    }
                    parsedInputPartList.push({
                      name: part.name,
                      quantity: quantity,
                      id: part.id
                    });
                    this.logger.info(
                      "Part " + inputPart + " matches with id " + part.id
                    );
                  }
                });
              }
            });
          }

          var inputProductList = JSON.parse(element.inputJson).products;
          if (Format.isNotNull(inputProductList)) {
            inputProductList.forEach(inputProduct => {
              if (Format.isNotNull(productList)) {
                productList.forEach(product => {
                  var parsedInputProduct = inputProduct;
                  if (parsedInputProduct.id === product.id) {
                    var quantity = 1;
                    if (parsedInputProduct.quantity) {
                      quantity = parsedInputProduct.quantity;
                    }
                    parsedInputProductList.push({
                      name: product.name,
                      quantity: quantity,
                      id: product.id
                    });
                    this.logger.info(
                      "Product " +
                        inputProduct +
                        " matches with id " +
                        product.id
                    );
                  }
                });
              }
            });
          }
        }

        if (Format.isNotNull(element.outputJson)) {
          var outputPartList = JSON.parse(element.outputJson).parts;
          if (Format.isNotNull(outputPartList)) {
            outputPartList.forEach(outputPart => {
              if (Format.isNotNull(partList)) {
                partList.forEach(part => {
                  var parsedOutputPart = outputPart;
                  if (parsedOutputPart.id === part.id) {
                    var quantity = 1;
                    if (parsedOutputPart.quantity) {
                      quantity = parsedOutputPart.quantity;
                    }
                    parsedOutputPartList.push({
                      name: part.name,
                      quantity: quantity,
                      id: part.id
                    });
                    this.logger.info(
                      "Part " + outputPart + " matches with id " + part.id
                    );
                  }
                });
              }
            });
          }

          var outputProductList = JSON.parse(element.outputJson).products;
          if (Format.isNotNull(outputProductList)) {
            outputProductList.forEach(outputProduct => {
              if (Format.isNotNull(productList)) {
                productList.forEach(product => {
                  var parsedOutputProduct = outputProduct;
                  if (parsedOutputProduct.id === product.id) {
                    var quantity = 1;
                    if (parsedOutputProduct.quantity) {
                      quantity = parsedOutputProduct.quantity;
                    }
                    parsedOutputProductList.push({
                      name: product.name,
                      quantity: quantity,
                      id: product.id
                    });

                    this.logger.info(
                      "Product " +
                        outputProduct +
                        " matches with id " +
                        product.id
                    );
                  }
                });
              }
            });
          }
        }

        // delete element.inputJson;
        // delete element.outputJson;

        var localInputComponentList = [];
        if (Format.isNotNull(parsedInputPartList)) {
          parsedInputPartList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "PART";
            localInputComponentList.push(localElement);
          });
        }
        if (Format.isNotNull(parsedInputProductList)) {
          parsedInputProductList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "SUB-ASSEMBLY";
            localInputComponentList.push(localElement);
          });
        }

        var localOutputComponentList = [];
        if (Format.isNotNull(parsedOutputPartList)) {
          parsedOutputPartList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "PART";
            localOutputComponentList.push(localElement);
          });
        }
        if (Format.isNotNull(parsedOutputProductList)) {
          parsedOutputProductList.forEach(element => {
            var localElement = Format.deepCopy(element);
            localElement.componentType = "SUB-ASSEMBLY";
            localOutputComponentList.push(localElement);
          });
        }

        element.inputComponentList = localInputComponentList;
        element.outputComponentList = localOutputComponentList;
        element.outputPartList = parsedOutputPartList;
        element.outputProductList = parsedOutputProductList;
      });
    }

    return localFlowBean;
  };

  renderJsonFromPartsAndProducts = (
    currentFlowBean,
    componentList,
    productId
  ) => {
    console.log(currentFlowBean);
    console.log(componentList);
    console.log(productId);

    var localFlowBean = Format.deepCopy(currentFlowBean);
    var i = 1;
    var lengthToCheck = localFlowBean.flowItemList.length;
    localFlowBean.flowItemList.forEach(element => {
      var parsedInputPartList = [];
      var parsedInputProductList = [];
      var parsedOutputPartList = [];
      var parsedOutputProductList = [];

      if (Format.isNotNull(element.inputComponentList)) {
        element.inputComponentList.forEach(inputPart => {
          componentList.forEach(part => {
            if (inputPart.name === part.name) {
              var quantity = 1;
              if (inputPart.quantity) {
                quantity = inputPart.quantity;
              }
              if (part.componentType === "PART") {
                parsedInputPartList.push({ id: part.id, quantity: quantity });
                this.logger.info(
                  "Part " + inputPart + " matches with id " + part.id
                );
              }
              if (part.componentType === "SUB-ASSEMBLY") {
                parsedInputProductList.push({
                  id: part.id,
                  quantity: quantity
                });
                this.logger.info(
                  "Product " + inputPart + " matches with id " + part.id
                );
              }
            }
          });
        });
      }

      //OUTPUT CODE COMMENTED OUT FOR NOW
      // if (Format.isNotNull(element.outputPartList)) {
      //   element.outputPartList.forEach(outputPart => {
      //     partList.forEach(part => {
      //       if (outputPart.name === part.name) {
      //         var quantity = 1;
      //         if (outputPart.quantity) {
      //           quantity = outputPart.quantity;
      //         }
      //         parsedOutputPartList.push({ id: part.id, quantity: quantity });
      //         this.logger.info(
      //           "Part " + outputPart + " matches with id " + part.id
      //         );
      //       }
      //     });
      //   });
      // }
      // if (Format.isNotNull(element.outputProductList)) {
      //   element.outputProductList.forEach(outputProduct => {
      //     productList.forEach(product => {
      //       if (outputProduct.name === product.name) {
      //         var quantity = 1;
      //         if (outputProduct.quantity) {
      //           quantity = outputProduct.quantity;
      //         }
      //         parsedOutputProductList.push({
      //           id: product.id,
      //           quantity: quantity
      //         });
      //         this.logger.info(
      //           "Product " + outputProduct + " matches with id " + product.id
      //         );
      //       }
      //     });
      //   });
      // }

      if (i === lengthToCheck) {
        this.logger.info("Found last item, adding " + productId);
        parsedOutputProductList.push({ id: productId, quantity: 1 });
      }

      var inputJson = {
        parts: parsedInputPartList,
        products: parsedInputProductList
      };
      var inputJsonString = JSON.stringify(inputJson);

      var outputJson = {
        parts: parsedOutputPartList,
        products: parsedOutputProductList
      };
      var outputJsonString = JSON.stringify(outputJson);

      element.inputJson = inputJsonString;
      element.outputJson = outputJsonString;
      delete element.inputPartList;
      delete element.inputProductList;
      delete element.outputPartList;
      delete element.outputProductList;
      delete element.inputComponentList;
      i++;
    });

    return localFlowBean;
  };
}



// WEBPACK FOOTER //
// ./src/components/Products/ProductViewModel.js